import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { Col, Row } from 'antd'
import { Formik } from 'formik'
import * as Yup from 'yup'

import AllowanceTypeAPI, {
  AllowanceTypeValues,
} from 'core/application/adminDashboard/benefitDetails/design/allowanceType'
import AllowanceType from 'core/domain/benefit/allowanceType'

import Radio from 'common/components/dataEntry/formik/FormikRadioField'
import notification from 'common/components/feedback/Notification'

import { commandRequest } from 'common/RequestUtils'

import { BaseComponentProps } from '../common/models'

import '../common/DesignStyles.less'

const formValidator = (translate: any) =>
  Yup.object({
    allowanceType: Yup.number().required(translate('general.required')),
  })

const SetAllowanceType: React.FC<BaseComponentProps<AllowanceTypeValues>> = (props) => {
  const { bindSubmitFormHandler } = props
  const initialValues: AllowanceTypeValues = { ...props.state }
  const { t: translate } = useTranslation()
  const { planPeriod } = useParams<any>()

  useEffect(() => {
    props.setIsFormValid(formValidator(translate).isValidSync(initialValues))
  }, [])

  const onSubmit = async (values: AllowanceTypeValues) => {
    let allowanceTypeValues: AllowanceTypeValues = {
      allowanceType: values.allowanceType,
      planPeriodId: planPeriod as string,
    }
    const res = await commandRequest(() => AllowanceTypeAPI(allowanceTypeValues))
    if (!res.errors) {
      props.goNext()
    } else {
      props.setIsSubmiting(false)
      notification.open({
        message: res.errors[0],
        type: 'error',
      })
    }
  }

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={formValidator(translate)}
      initialValues={initialValues}
      onSubmit={onSubmit}
      validate={(values) => {
        props.hasDirtyData(true)
        props.setIsFormValid(formValidator(translate).isValidSync(values))
        return {}
      }}
    >
      {(formik) => {
        const { handleSubmit, submitForm } = formik
        bindSubmitFormHandler(submitForm)
        return (
          <form onSubmit={handleSubmit}>
            <Row>
              <Col sm={{ span: 24, offset: 0 }} lg={{ span: 22, offset: 1 }} className="benefit_design_page_header">
                <h5>{translate('admin-dashboard.benefit-details.allowance-type.header')}</h5>
              </Col>
            </Row>
            <Row justify={'center'} gutter={10} className="form__row">
              <Col sm={24} lg={22}>
                <Radio.Group
                  name="allowanceType"
                  defaultValue={initialValues.allowanceType}
                  disabled={props.showAsReadOnly}
                >
                  <Row gutter={10} className="allowance_type">
                    <Col span={12}>
                      <Radio.Button
                        className="custom-medium radio-with-checkmark allowance_type_radio"
                        value={AllowanceType.Annual}
                      >
                        <div className="p-8">
                          <h5 className="first_title">
                            {translate('admin-dashboard.benefit-details.allowance-type.full-allowance-header')}
                          </h5>
                          <h6 className="option_title pt-16">
                            {translate('admin-dashboard.benefit-details.allowance-type.full-allowance-desc')}
                          </h6>
                        </div>
                      </Radio.Button>
                    </Col>
                    <Col span={12}>
                      <Radio.Button
                        className="custom-medium radio-with-checkmark allowance_type_radio"
                        value={AllowanceType.Monthly}
                      >
                        <div className="p-8">
                          <h5 className="first_title">
                            {translate('admin-dashboard.benefit-details.allowance-type.monthly-allowance-header')}
                          </h5>
                          <h6 className="option_title pt-16">
                            {translate('admin-dashboard.benefit-details.allowance-type.monthly-allowance-desc')}
                          </h6>
                        </div>
                      </Radio.Button>
                    </Col>
                  </Row>
                </Radio.Group>
              </Col>
            </Row>
          </form>
        )
      }}
    </Formik>
  )
}

export default SetAllowanceType
